import React from "react";
import PropTypes from "prop-types";
import Expander from "../../../../components/Expander";

const { string, arrayOf } = PropTypes;

const urlify = (text) => {
  const urlRegex = new RegExp(/\[MIM:[0-9]*\]/g);
  return text.replace(urlRegex, (url) => {
    return `<a href="https://www.omim.org/entry/${url
      .split(":")[1]
      .replace(/]/, "")}" target="_blank">${url}</a>`;
  });
};

const getDiseaseDescriptionTable = (descriptions) => {
  const diseaseDescriptionsTableBody = descriptions.map((item, i) => {
    const des = { __html: urlify(descriptions[i]) };
    const tableRow = (
      <tr key={i}>
        <td>
          {/* TODO: we can remove dangerouslySetInnerHTML by changing urlify  */}
          {/*  eslint-disable-next-line react/no-danger */}
          <span dangerouslySetInnerHTML={des} />
        </td>
      </tr>
    );
    return tableRow;
  });

  const diseaseDescriptionsTable = (
    <table className="varsome-table">
      <Expander showMore="4" component="tbody">
        {diseaseDescriptionsTableBody}
      </Expander>
    </table>
  );

  return diseaseDescriptionsTable;
};

const DiseaseDescriptions = ({ descriptions }) => {
  if (Array.isArray(descriptions) && descriptions.length > 0) {
    return (
      <div className="tw-mt-4">
        <div>
          <h5>Disease Descriptions (UniProt)</h5>
          {getDiseaseDescriptionTable(descriptions)}
        </div>
      </div>
    );
  }

  return null;
};

DiseaseDescriptions.propTypes = {
  descriptions: arrayOf(string),
};

DiseaseDescriptions.defaultProps = {
  descriptions: null,
};
export default DiseaseDescriptions;
